// 了解房源关联
export const linkListingsDoc = (international) => {
  return international ? 'https://hostex.io/help/link-listings/' : 'https://www.myhostex.com/help/?p=560';
};

// 帮助文档
export const helpDoc = (international) => {
  return international ? 'https://hostex.io/help/' : 'https://www.myhostex.com/help/';
};

// 如何设置智能门锁
export const smartLockDoc = (international) => {
  return international
    ? 'https://hostex.io/help/integrate-smart-lock-systems/'
    : 'https://www.myhostex.com/help/?p=268';
};

// 如何使用入住管理
export const checkInfoDoc = (international) => {
  return international ? 'https://hostex.io/help/check-in-guide/' : 'https://www.myhostex.com/help/?p=263';
};

// 详细了解爱彼迎直连
export const airbnbLinkDoc = (international) => {
  return international
    ? 'https://hostex.slab.com/posts/what-do-you-need-to-know-about-the-airbnb-connection-with-hostex-4nj8nwei'
    : 'https://www.yuque.com/baijuyi_help/faq/airbnb-api-connecting';
};

// 开启爱彼迎多库存
export const airbnbInventoryDoc = (international) => {
  return international
    ? 'https://hostex.slab.com/posts/how-to-enable-multi-inventory-for-an-airbnb-listing-wlekqjd5'
    : 'https://www.yuque.com/baijuyi_help/web/airbnb_inventory';
};

export const receiveAccountDoc = () => {
  return 'https://hostex.io/help/stripe-integration/';
};

// 订单分配
export const reservationAlloDoc = (international) => {
  return international ? 'https://hostex.io/help/room-allocation/' : 'https://www.myhostex.com/help/?p=203';
};

// 批量改价
export const batchModifyPriceDoc = (international) => {
  return international ? 'https://hostex.io/help/change-prices/' : 'https://www.myhostex.com/help/?p=229';
};

// 自动化
export const automationDoc = (international) => {
  return international ? 'https://hostex.io/help/category/automation/' : 'https://www.myhostex.com/help/?cat=27';
};

// 押金
export const depositDoc = (international) => {
  return international ? 'https://hostex.io/help/security-deposit/' : 'https://hostex.io/help/security-deposit/';
};

// 定价比例
export const channelPriceRatioDoc = (international) => {
  return international ? 'https://hostex.io/help/pricing-ratio/' : 'https://www.myhostex.com/help/?p=243';
};

// 主导渠道
export const leadChannelDoc = (international) => {
  return international ? 'https://hostex.io/help/lead-channel/' : 'https://www.myhostex.com/help/?p=245';
};

// room types
export const roomTypesDoc = (international) => {
  return international ? 'https://hostex.io/help/room-type/' : 'https://www.myhostex.com/help/?p=95';
};

// 小红书
export const xhsDoc = () => {
  return 'https://www.myhostex.com/help/?p=137';
};
